import * as customModules from 'plugins/PageModules';

export const pageModules = {
  text: { id: 1, icon: 'ModuleText' },
  video: { id: 2, icon: 'ModuleVideo' },
  image: { id: 3, icon: 'ModuleImage' },
  audio: { id: 4, icon: 'ModuleAudio' },
  embed: { id: 5, icon: 'ModuleEmbed' },
  task: { id: 6, icon: 'ModuleInteraction' },
  download: { id: 7, icon: 'ModuleDownload' },
  discussion: { id: 8, icon: 'ModuleDiscussion' },
  slideshow: { id: 9, icon: 'ModuleTask' },
  quiz: { id: 10, icon: 'ModuleInteraction' },
  webinar: { id: 11, icon: 'ModuleWebinar' },
  quiziframe: { id: 12, icon: 'ModuleQuiziframe' },
};

Object.keys(customModules).forEach(moduleName => {
  const module = customModules[moduleName];
  pageModules[moduleName] = {
    active: module.active,
    public: module.public,
    id: module.type,
    plugin: true
  };
});

export const NO_TIME = '0000-00-00 00:00:00';
export const DEFAULT_COVER = '/images/cover_default.png';
export const DEFAULT_CURRENCY = 'SEK';
// pageModules: {
//   helloWorld: {id: 1000, plugin: true},
//   webinar: {id: 1001, plugin: true},
//   oscilloscope: {id: 1002, plugin: true},
//   instagramFeed: {id: 1003, plugin: true},
// },
export const ItemTypes = {
  MODULE: 'module',
  ROW: 'row',
  TOC_SECTION: 'toc-section',
  TOC_PAGE: 'toc-page',
  LIST_ITEM: 'listitem'
};

export const fileTypeIcons = {
  audio: 'audio'
};

export const paymentProviders = {
  STRIPE: 6,
  KLARNA: 5,
  PAYPAL: 2,
  KLARNACHECKOUT: 9
};

export const taskTypes = {
  SINGLE_CHOICE: 1,
  MULTI_CHOICE: 2,
  TEXT: 4
};

export const NOTIFICATIONS = {
  NOTIFICATION_ADDED_TO_CIRCLE: 1,
  NOTIFICATION_TASK_FEEDBACK: 2,
  NOTIFICATION_POST_ADDED: 3,
  NOTIFICATION_TASK_ASSESSED: 4,
  NOTIFICATION_YOU_MENTIONED: 5,
  NOTIFICATION_FEEDBACK_REQUIRED: 6,
  NOTIFICATION_UNREVIEWED_TASKS: 7,
  NOTIFICATION_THREAD_NEW_POSTS: 8,
  NOTIFICATION_COURSE_NEW_POSTS: 9,
  NOTIFICATION_COURSE_SOLD: 10,
  NOTIFICATION_COURSE_PACKAGE_SOLD: 11,
  NOTIFICATION_ADDED_TO_COURSE: 12,
  NOTIFICATION_DRIP_CONTENT: 14,
  NOTIFICATION_DATA_EXPORT: 15,
  NOTIFICATION_COURSE_INVITE: 16,
  NOTIFICATION_BROADCAST: 17
};

export const features = {
  diplomas: 'Diplomas',
  dripContent: 'Drip content',
  enterpriseStore: 'Enterprise store',
  klarnaCheckout: 'Klarna checkout',
  quiz: 'Quiz',
  showTaskResultOnAnswer: 'Show taskresult on answer'
};

export const paymentSettings = {
  nonProfit: 'NonProfit'
};

export const maxFileSize = 512 * 1024 * 1024;

export const notificationPageLength = 100;

export default {
  pageModules,
  features,
  paymentSettings,
  NOTIFICATIONS,
  NO_TIME,
  DEFAULT_CURRENCY,
  DEFAULT_COVER,
  ItemTypes,
  fileTypeIcons,
  paymentProviders,
  taskTypes,
  notificationPageLength
};



// WEBPACK FOOTER //
// ./src/js/Constants.js